import {
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useDisclosure
} from '@chakra-ui/react'
import GroupItem from '../../Groups/GroupItem'
import usePrintDetailedProductSales from '../../hooks/usePrintDetailedProductSales'
import ContentForm from './ContentForm'

export default function ModalDetailedProductSales() {
    const { isLoading, submit } = usePrintDetailedProductSales()
    const { isOpen, onClose, onOpen } = useDisclosure()

    return (
        <>
            <GroupItem onClick={onOpen} label="Venta Detallada de Productos" />
            <Modal isOpen={isOpen} onClose={onClose} size="sm">
                <ModalOverlay />
                <ModalContent p={4} pb={6}>
                    <ModalHeader textAlign="center">
                        Reporte de Ventas Detallada de Productos
                    </ModalHeader>
                    <ModalBody>
                        <ContentForm onSubmit={submit} isLoading={isLoading} />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
